import axios from 'axios';
import { apiBaseUrl } from '../urlPaths';

export default axios.create({
    baseURL: apiBaseUrl,
    headers: {
        'Content-Type': 'application/json'
    },
    //Authorization: `Bearer ${token}`
});